import { HIVE_LINKED_DOC_WIDGET } from './config.js';
import { ImportDoc } from './import-doc/import-doc.js';
import { Loader } from './import-doc/loader.js';
import { HiveLinkedDocWidget } from './index.js';
import { LinkedDocPopover } from './linked-doc-popover.js';
import { HiveMobileLinkedDocMenu } from './mobile-linked-doc-menu.js';

export function effects() {
  customElements.define('hive-linked-doc-popover', LinkedDocPopover);
  customElements.define(HIVE_LINKED_DOC_WIDGET, HiveLinkedDocWidget);
  customElements.define('import-doc', ImportDoc);
  customElements.define(
    'hive-mobile-linked-doc-menu',
    HiveMobileLinkedDocMenu
  );
  customElements.define('loader-element', Loader);
}
